import { createContext } from 'react';

import { UseChartsData } from './_hooks/useChartsData';

export const GaugeChartsContext = createContext<UseChartsData>({} as never);
